<template>
    <div class="af" v-loading="loading">
        <div class="flex w100 alc marl4" >
            <el-button size="small" type="primary" :class="baseerp+'btn'" @click="changefrom">{{$t('saleInvoicing_upload_attachment')}}</el-button>
        </div>
        <el-table
                ref="table"
                size="mini"
                border
                :data="tableData"
                height="275"
                style="width: 100%"
                class="marT10"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow"
                @row-click="clickrow">
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_invoice_code"
                    :label="$t('saleInvoicing_invoice_number')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span :class="scope.row.f_pay<0?'red':''">{{scope.row.vc_invoice_code}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_fppzname"
                    label="品种"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="scope.row.f_pay<0?'red':''">{{scope.row.detailCount>1?(scope.row.vc_fppzname+'等'+scope.row.detailCount+'个'):scope.row.vc_fppzname}}</span>
                    </template>
            </el-table-column>
            <el-table-column
                    prop="f_pay"
                    label="开票金额"
                    show-overflow-tooltip
                    align="right">
                <template slot-scope="scope">
                    <span :class="scope.row.f_pay<0?'red':''">{{scope.row.f_pay}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_note"
                    label="备注"
                    show-overflow-tooltip
                    width="150px">
                <template slot-scope="scope">
                    <span :class="scope.row.f_pay<0?'red':''">{{scope.row.vc_note}}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    prop="vc_mainfile_newname"
                    :label="$t('saleInvoicing_attachment')"
                    show-overflow-tooltip
                    width="55px">
                <template slot-scope="scope">
                    <a :href="file_root+scope.row.vc_file" target="_blank">
                        <i :class="scope.row.f_pay<0?'red el-icon-paperclip':'el-icon-paperclip'" v-show="scope.row.vc_file"></i>
                    </a>
                </template>
            </el-table-column>
        </el-table>
        <!--<el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>-->
        <!--<div class="flex mrl20 mrb20 img-box" v-if="i_isfrom==0">
            &lt;!&ndash;<div class="upload-box" v-if="vc_newname==''">
                <input type="file" name="files" id="uploadfile1"
                       class="upload-input uploadfile1" @change="uploadFile" style="margin-right: 10px"
                >
                <el-button size="small" type="primary" :class="baseerp+'btn'"> 上传附件</el-button>
            </div>&ndash;&gt;
            <ul  class="uploadPhon flex list" id="formul" v-if="vc_newname">
                <li class="li-img ale" v-for="(oneimg,index) in files" :key="index">
                    <a
                            :href="file_root+oneimg.vc_path" target="_blank">
                        {{oneimg.vc_name}}
                    </a>
                    &lt;!&ndash;<a
                        :download="oneimg.vc_name"
                        mce_href="#"
                        :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+oneimg.filenewname+',deliver\'}','utf-8')">
                        {{oneimg.vc_name}}
                    </a>&ndash;&gt;
                    <i class="el-icon-delete" @click="clearFile(oneimg,index)" v-if="vc_newname"></i>
                </li>
            </ul>
        </div>-->
        <!--<span class="fl" style="margin-left:4px;height:21px;line-height: 50px;font-size: 10px;color: #fa5050;text-decoration: underline" @click="openfresh">找不到数据？点击此处</span>-->
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('saleInvoicing_cancel')}}</el-button>
        </div>
        <!--dialog-->
        <el-dialog
                :class="baseerp+'div'"
                width="600px"
                :title="$t('saleInvoicing_upload_attachment')"
                :visible.sync="dialogVisible_upl"
                :close-on-click-modal="false"
                @close="cancelDialog_upl"
                v-if="dialogVisible_upl"
                :append-to-body="true"
                >
            <div v-loading="loading_upl">
                <div class="flex_b">
                    <el-upload
                            class="upload-demo"
                            :action="action"
                            :data="data"
                            :http-request="beupload"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="limit"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                        <el-button :class="baseerp+'btn'" size="mini" type="primary">{{$t('saleInvoicing_select_file')}}</el-button>
                    </el-upload>
                    <div>
                        <el-button :class="baseerp+'btn'" size="mini" type="primary" @click="submitUpload">{{$t('saleInvoicing_upload')}}</el-button>
                    </div>
                </div>

                <!--<div class="flex mrl20 mrb20 img-box">
                    <div class="upload-box" >
                        <input type="file" name="files" id="uploadfile1"
                               class="upload-input uploadfile1" @change="uploadFile" style="margin-right: 10px"
                        >
                        <el-button size="small" type="primary" :class="baseerp+'btn'">上传附件</el-button>
                    </div>
                    <ul  class="uploadPhon flex list" id="formul" >
                        <li class="li-img ale" v-for="(oneimg,index) in files" :key="index">
                            <a
                                    :href="file_root+oneimg.vc_path" target="_blank">
                                {{oneimg.vc_name}}
                            </a>
                            &lt;!&ndash;<a
                                :download="oneimg.vc_name"
                                mce_href="#"
                                :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+oneimg.filenewname+',deliver\'}','utf-8')">
                                {{oneimg.vc_name}}
                            </a>&ndash;&gt;
                            <i class="el-icon-delete" @click="clearFile(oneimg,index)" v-if="vc_newname"></i>
                        </li>
                    </ul>
                </div>-->
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('saleInvoicing_invoice_number')}}</span>
                    <el-input class="wid100" size="mini"  v-model="vc_fpcode_upl">
                    </el-input>
                </div>
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('saleInvoicing_product_name')}}</span>
                    <el-input disabled class="wid100" size="mini"  v-model="vc_pz_upl">
                    </el-input>
                </div>
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('saleInvoicing_tax_exempt_amount')}}</span>
                    <el-input-number class="wid100" @change="wspay"  :controls="false"  :precision="2"  size="mini" v-model="f_pay_ws_upl" ></el-input-number>
                </div>
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('saleInvoicing_tax_amount')}}</span>
                    <el-input-number class="wid100" @change="sepay" :controls="false" :precision="2"  size="mini" v-model="f_pay_zzs_upl" ></el-input-number>
                </div>
                <div class="flex w100 marT10 alc" v-if="i_flag==1">
                    <span class="marr4 font14">{{$t('saleInvoicing_tariff')}}</span>
                    <el-input-number class="wid100" @change="gspay" :controls="false" :precision="2"  size="mini" v-model="f_gs_upl" ></el-input-number>
                </div>
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('saleInvoicing_total_amount')}}</span>
                    <el-input-number class="wid100" @change="totalpay" :controls="false"  :precision="2"  size="mini" v-model="f_pay_upl" ></el-input-number>
                </div>
                <!--<div class="flex w100 marT10 alc">
                    <span class="marr4 font14">备注</span>
                    <el-input class="wid100" size="mini"  v-model="vc_note_upl">
                    </el-input>
                </div>-->
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('saleInvoicing_invoice_time')}}</span>
                    <el-date-picker
                            style="width: 190px"
                            v-model="dt_fptime"
                            size="mini"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            :placeholder="$t('saleInvoicing_select_date')"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
                    <el-button @click="saveupl" type="primary"  :class="baseerp+'btn'" size="small">{{$t('saleInvoicing_sure')}}</el-button>
                    <el-button @click="cancelDialog_upl(null)" size="small">{{$t('saleInvoicing_cancel')}}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>

</template>
<script>
    import * as API from "./api"
    import {file_root} from "@/utils/baseUrl";
    import {baseerp} from "@/utils/baseUrl";
    import {erpplatserver} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {
        },
        props:{
            fpData:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                action:erpplatserver+'/system/uploadInvoice',
                data:{
                    // "file": fileId,
                    // "fileName": that.fileName,
                    // "IDtype": "",
                    // "type": 1,
                    "style": "invoicepool",
                    //"token":sessionStorage.getItem("token"),
                    //"app": "dsmanage",
                    "vc_app": "invoicepool",
                    "i_appid": 0,
                    // "version": "1.0",
                    // "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    // "i_mid": this.mid
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()  // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                },
                details_upl:[],
                copyfpcode:'',
                i_glfpid:0,
                i_bzid_yb:1,
                dt_fptime:'',
                vc_fpcode_upl:'',
                vc_pz_upl:'',
                f_pay_ws_upl:'',
                f_pay_zzs_upl:'',
                f_gs_upl:'',
                f_pay_upl:'',
                vc_note_upl:'',
                dialogVisible_upl:false,
                invoiceType:'1',
                vc_newname:"",
                files: [],
                disabled:true,
                i_isfrom:1,
                loading:false,
                loading_upl:false,
                file_root:"",
                baseerp:"",
                mid:0,
                vc_fkey:"",
                form:[],
                compsData:[],
                companyName:'',
                companyId:0,
                vc_gscreditcode:"",
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                vc_khcreditcode:"",
                xsComId:0,
                xsComname:'',
                //i_dlkhid:0,
                //vc_dlkhname:'',
                fpType:[],
                i_type:0,
                i_khtype:0,
                i_origin_khtype:0,
                vc_fymx:'',
                i_issd:0,
                i_flag:0,
                i_isagent:0,
                vc_type:"",
                tableData:[],
                highlightCurrentRow:false,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                vc_search:'',
                isdk:0,
                upfiles:[],
                fileList:[],
                limit:1,
                fpFliedata:{},
                json_invoice_data:{},
            }
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            this.file_root = file_root;
            console.log(this.fpData.i_invoicetype,'this.fpData')


        },
        methods:{
            keepTwoDecimal(num) {
                var result = parseFloat(num);
                if (isNaN(result)) {
                    result = 0;
                }else{
                    result = Math.round(num * 100) / 100;//保留两位

                }
                return result;
            },
            async submitUpload() {
                this.loading_upl=true;
                var param = {
                    // "file": fileId,
                    // "fileName": that.fileName,
                    // "IDtype": "",
                    // "type": 1,
                    "style": "invoicepool",
                    //"token":sessionStorage.getItem("token"),
                    //"app": "dsmanage",
                    "vc_app": "invoicepool",
                    "i_appid": 0,
                    // "version": "1.0",
                    // "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    // "i_mid": this.mid
                };
                for (let i = 0; i < this.fileList.length; i++) {
                    //param.append("file", this.fileList[i]);
                    param['flie'+[i]]=this.fileList[i]
                }
                //console.log(param,'param')
                let res = await API.uploadInvoice(param);
                if (res.code == 1) {
                    this.files=res.data.fileList;
                    this.loading_upl=false;
                    this.$forceUpdate()
                    if(res.data.apicode==1){
                        let invoice = res.data.invoice;
                        let details = invoice.details;
                        this.fpFliedata.vc_invoice_code=invoice.vc_fpcode;
                        this.fpFliedata.json_invoice_data=invoice;
                        this.fpFliedata.vc_file=this.files[0].vc_path;
                        //console.log('this.fpFliedata',this.fpFliedata)
                        this.details_upl = invoice.details;
                        let detailsL = invoice.details.length;
                        this.vc_fpcode_upl = invoice.vc_fpcode;
                        this.vc_pz_upl = detailsL==0?'':(detailsL==1?details[0].vc_fppzname:details[0].vc_fppzname+'等');
                        this.f_pay_ws_upl = invoice.f_pay_ws;
                        this.f_pay_zzs_upl = invoice.f_pay_zzs;
                        this.f_pay_upl = invoice.f_pay;
                        this.vc_note_upl = invoice.vc_note;
                        this.f_gs_upl = invoice.f_gs;
                        this.dt_fptime = invoice.dt_fptime;
                        this.vc_mainfile_newname= invoice.vc_mainfile_newname;
                    }else{
                        this.fpFliedata.vc_invoice_code='';
                        this.fpFliedata.json_invoice_data={};
                        this.fpFliedata.vc_file=this.files[0].vc_path;
                        //console.log('this.fpFliedata',this.fpFliedata)
                        let string='';
                        string=res.data.fileList.map(item=>item.vc_path).join(';')
                        //console.log(string,'string')
                        this.vc_mainfile_newname=string;
                    }
                } else if (res.code == -2) {
                    this.loading_upl=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading_upl=false;
                    this.$message.error(res.message);
                }

            },
            beupload(obj){
                this.fileList.push(obj.file)
                //console.log(this.fileList, 'this.fileList');
            },
            change(file, fileList){
                //console.log(file, fileList,'console.log(file, fileList)');
            },
            handleRemove(obj, fileList) {
                this.fileList=fileList;
                //console.log(this.fileList, 'this.fileList');
                if(this.fileList.length==0){
                    this.vc_newname='';
                    this.vc_fpcode_upl='';
                    this.vc_pz_upl='';
                    this.f_pay_ws_upl='';
                    this.f_pay_zzs_upl='';
                    this.f_pay_upl='';
                    this.vc_note_upl='';
                    this.f_gs_upl='';
                }
            },
            handlePreview(file) {
                //console.log(file,'file---');
            },
            handleExceed(files, fileList) {
                this.$message.warning(this.$t('saleInvoicing_the_current_restriction_is_to_select_files_this_time_files_were_selected_and_a_total_of_files_were_selected',[this.limit,files.length,files.length + fileList.length]));
                //this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(` ${ this.$t('saleInvoicing_confirm_removal')+file.name }？`);
            },
            wspay(){
                //console.log(this.f_pay_ws_upl,'this.f_pay_ws_upl')
                if(!this.f_pay_ws_upl){
                    this.f_pay_ws_upl=0
                }
                if(this.fpData.i_invoicetype==1&&this.f_pay_ws_upl<=0){
                    this.$message.error(this.$t('saleInvoicing_tax_exclusive_amount_cannot_le_zero'));
                    this.$nextTick(() => {
                        this.f_pay_ws_upl = 0;
                        this.f_pay_upl = parseFloat(this.f_pay_ws_upl + this.f_pay_zzs_upl) || 0;
                    });
                    return
                }
                if(this.fpData.i_invoicetype==2&&this.f_pay_ws_upl>=0){
                    this.$message.error(this.$t('saleInvoicing_tax_exclusive_amount_cannot_ge_zero'));
                    this.$nextTick(() => {
                        this.f_pay_ws_upl = 0;
                        this.f_pay_upl = parseFloat(this.f_pay_ws_upl + this.f_pay_zzs_upl) || 0;
                    });
                    return
                }
                let cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl;
                cenzzs = parseFloat(cenzzs);
                //console.log(cenzzs,'cenzzs')
                this.f_pay_upl = cenzzs;
            },
            sepay(){
                if(!this.f_pay_zzs_upl){
                    this.f_pay_zzs_upl=0
                }
                if(this.fpData.i_invoicetype==1&&this.f_pay_zzs_upl<=0){
                    this.$message.error(this.$t('saleInvoicing_tax_amount_cannot_le_zero'));
                    this.$nextTick(() => {
                        this.f_pay_zzs_upl = 0;
                        this.f_pay_upl = parseFloat(this.f_pay_ws_upl + this.f_pay_zzs_upl) || 0;
                    });
                    return
                }
                if(this.fpData.i_invoicetype==2&&this.f_pay_zzs_upl>=0){
                    this.$message.error(this.$t('saleInvoicing_tax_amount_cannot_ge_zero'));
                    this.$nextTick(() => {
                        this.f_pay_zzs_upl = 0;
                        this.f_pay_upl = parseFloat(this.f_pay_ws_upl + this.f_pay_zzs_upl) || 0;
                    });
                    return
                }
                //console.log(this.f_pay_zzs_upl,'this.f_pay_zzs_upl')
                let cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl;
                cenzzs = parseFloat(cenzzs);
                //console.log(cenzzs,'cenzzs')
                this.f_pay_upl = cenzzs;
            },
            gspay(){
                if(!this.f_gs_upl){
                    this.f_gs_upl=0
                }
                //console.log(this.f_gs_upl,'this.f_gs_upl')
                let cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl + this.f_gs_upl;
                cenzzs = parseFloat(cenzzs);
                //console.log(cenzzs,'cenzzs')
                this.f_pay_upl = cenzzs;
            },
            totalpay(){
                //console.log(this.f_pay_ws_upl,'f_pay_ws_upl')
                //console.log(this.f_pay_zzs_upl,'f_pay_zzs_upl')
                //console.log(this.f_pay_upl,'f_pay_upl')
                if(this.f_pay_upl == 0 || !this.f_pay_upl){
                  //this.$message.error("总金额不可小于0！ ");
                    this.f_pay_ws_upl=0;
                    this.f_pay_zzs_upl=0;
                    this.f_pay_upl = 0;
                    this.f_gs_upl = 0;
                    return ;
                }
                let cenzzs=0;
                if(this.i_flag==1){
                    cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl + this.f_gs_upl
                }else{
                    cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl;
                }
                cenzzs = parseFloat(cenzzs);
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                if(this.f_pay_upl<less||this.f_pay_upl>more){
                    this.$nextTick(()=>{
                        this.f_pay_upl = cenzzs;
                    })
                    this.$message.error(this.$t('saleInvoicing_the_total_amount_cannot_exceed_or_be_less_than_the_established_total_amount')+cenzzs+"±1！");
                }

            },
            saveupl(){

                if(this.files.length==0){
                    this.$message.error(this.$t('saleInvoicing_please_upload_the_attachment'));
                    return;
                }
                if(this.vc_fpcode_upl==''){
                    this.$message.error(this.$t('saleInvoicing_invoice_number_cannot_be_empty'));
                    return;
                }
                if(this.dt_fptime==''||this.dt_fptime==null){
                    this.$message.error(this.$t('saleInvoicing_the_invoicing_time_cannot_be_empty'));
                    return;
                }
                //console.log('this.fpFliedata',this.fpFliedata);
                this.fpFliedata.vc_invoice_code=this.vc_fpcode_upl;
                this.fpFliedata.json_invoice_data.vc_fpcode=this.vc_fpcode_upl;
                this.fpFliedata.json_invoice_data.dt_fptime=this.dt_fptime;
                this.fpFliedata.json_invoice_data.f_gs=this.f_gs_upl;
                this.fpFliedata.json_invoice_data.f_pay=this.f_pay_upl;
                this.fpFliedata.json_invoice_data.f_pay_ws=this.f_pay_ws_upl;
                this.fpFliedata.json_invoice_data.f_pay_zzs=this.f_pay_zzs_upl;
                this.cancelDialog_upl(this.fpFliedata);
                //this.$emit('confirm',{data:this.fpFliedata})
                //this.saveToPool();

            },
            async saveToPool(){
                this.loading=true;
                let param={
                    //"i_id": this.i_id,
                    "i_type": this.i_type, //发票类型，2：采购发票， 3： 运费发票 ，32：港杂发票， 4：开证发票 ， 5： 仓储发票 ， 6：保险发票
                    //'i_khtype':this.i_khtype==4?2:this.i_khtype,
                    'i_fptype':this.i_fptype,
                    'vc_fptype':this.vc_fptype,
                    "vc_fpcode": this.vc_fpcode_upl,//发票编号,
                    "i_kpkhid":this.i_kpkhid,
                    "vc_kpkhname":this.vc_kpkhname,
                    //"i_kpkhid": this.i_isagent==1?this.xsComId:this.i_kpkhid , //销售方，代开时为销售方，非代开时为开票方
                    //"vc_kpkhname":this.i_isagent==1?this.xsComname:this.vc_kpkhname ,//开票方
                    "vc_khcreditcode":this.vc_khcreditcode, //开票方识别号
                    "vc_gscreditcode":this.vc_gscreditcode, //开票方识别号
                    "dt_fptime":this.dt_fptime, //开票日期
                    "i_gsid":this.companyId,
                    "vc_gsname": this.companyName,
                    "i_isagent":this.i_isagent, //是否代开，1是0否
                    'i_dkable':this.isdk,
                    //"i_dlkhid": this.i_isagent==1?this.i_kpkhid:0 ,
                    //"vc_dlkhname":this.i_isagent==1?this.vc_kpkhname:'' , //代理开票方,
                    "f_pay": this.f_pay_upl, //开票金额
                    "f_pay_ws": this.f_pay_ws_upl,
                    "f_pay_zzs": this.f_pay_zzs_upl,
                    'f_gs':this.f_gs_upl,
                    "vc_note": this.vc_note_upl,
                    "i_isfrom": this.i_isfrom, //来源，0来源于税务云，1来源于员工上传
                    "vc_mainfile_newname":this.vc_mainfile_newname,//发票上传附件的newname
                    //"vc_mainfile_newname":this.vc_newname,
                    'details':this.details_upl,
                    //"delIds":this.delIds,
                    //'vc_fkey':this.i_isfrom==1?this.vc_fkey:"",
                    //'vc_no':this.orderWs,
                    'i_gid':sessionStorage.getItem("i_gid"),
                    'i_bzid_yb':this.i_bzid_yb,
                    'i_invoiceType':this.invoiceType,
                    'vc_relateinvoice_code':this.invoiceType=='2'?this.copyfpcode:null,
                    'i_glfpid':this.invoiceType=='2'?this.i_glfpid:null,
                    'inputOrOutput':"0",//采购
                };
                //console.log(param,'param')
                //return;
                let res=await API.saveToPool(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.dialogVisible_upl=false;
                    this.files=[];
                    this.fileList=[];
                    this.vc_newname='';
                    this.vc_fpcode_upl='';
                    this.vc_pz_upl='';
                    this.f_pay_ws_upl='';
                    this.f_pay_zzs_upl='';
                    this.f_pay_upl='';
                    this.vc_note_upl='';
                    this.f_gs_upl='';
                    this.dt_fptime='';
                    this.details_upl=[];
                    this.beforehandle();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            cancelDialog_upl(arr){
                this.dialogVisible_upl=false;
                this.files=[];
                this.fileList=[];
                this.vc_newname='';
                this.vc_fpcode_upl='';
                this.vc_pz_upl='';
                this.f_pay_ws_upl='';
                this.f_pay_zzs_upl='';
                this.f_pay_upl='';
                this.f_gs_upl='';
                this.vc_note_upl='';
                if(arr){
                    const newData = JSON.parse(JSON.stringify(arr)); // 深拷贝一次
                    this.tableData.push(newData);
                    //console.log('this.tableData--2',this.tableData)
                }

            },
            changefrom(e){
                if(this.i_flag==1){
                    this.limit=2;
                }else{
                    this.limit=1;
                }
                this.dialogVisible_upl=true;
                /*console.log('e',e)
                this.i_isfrom=e;
                if(this.i_isfrom==0){

                }*/

            },
            openfresh() {
                this.$confirm(this.$t('saleInvoicing_we_will_pull_the_latest_data_from_the_invoice_pool_please_ensure_that_we_have_contacted_the_finance_department_offline_to_retrieve_the_invoices_again_are_you_sure_you_want_to_confirm_the_retrieval_of_the_data'), this.$t('saleInvoicing_hint'), {
                    confirmButtonText: this.$t('saleInvoicing_sure'),
                    cancelButtonText: this.$t('saleInvoicing_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.refresh();
                }).catch(() => {

                });
            },
            async refresh(){
                this.loading=true;
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.refresh(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            gosearch(){
                //if(this.i_isfrom==1){
                    this.currentPage=1;
                    this.tableData=[];
                    this.beforehandle();
                //}

            },
            handleSizeChange(val){
                /*this.pageSize=val;
                this.currentPage=1;
                this.beforehandle();*/
                //if(this.i_isfrom==1){
                    this.pageSize=val;
                    this.currentPage=1;
                    this.beforehandle();
                //}
            },
            handleCurrentChange(val){
                /*this.currentPage=val;
                this.beforehandle();*/
                //if(this.i_isfrom==1){
                    this.currentPage=val;
                    this.beforehandle();
                //}
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                    this.currentPage=1;
                    this.tableData=[];
                    this.beforehandle();
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }

            },
            clickrow(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
                this.vc_fkey=row.vc_fkey;
                this.form=row;
                //this.application.i_pid=row.i_pid;
                //console.log(this.application,"this.application")
            },


            //根据开票方获取发票编号列表
            async beforehandle(){
                let param = {
                    'i_mid':this.mid,
                    'vc_kpkhname':this.vc_kpkhname,
                    'vc_khcreditcode':this.vc_khcreditcode,
                    'vc_gsname':this.companyName,
                    'vc_gscreditcode':this.vc_gscreditcode,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_search':this.vc_search,
                    //'invoiceType':this.invoiceType,
                };
                let res = await API.beforehandle(param);
                if (res.code == 1) {
                    res.data.list.map(item=>{
                        let files=[];
                        let arr = item.vc_mainfile_newname.split(';')
                        arr.map((subitem,subindex)=>{
                            let map={}
                            map.vc_mainfile_newname=subitem;
                            map.vc_filename=item.vc_fpcode+'_'+subindex;
                            files.push(map)
                        })
                        item.files=files;
                    })
                    this.tableData = res.data.list;
                    this.tableTotal = res.data.total;
                    //console.log(this.tableData,'this.tableData')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取交易公司
            async getCompanyList(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //查询开票类型
            async fptype(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.fptype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.i_type = res.data.list[0].i_id;
                    this.vc_type = res.data.list[0].vc_name;
                    this.i_khtype = res.data.list[0].i_khtype;
                    this.i_origin_khtype = res.data.list[0].i_origin_khtype;
                    this.vc_fymx= res.data.list[0].vc_fymx;
                    //this.i_isagent = res.data.list[0].i_isagent;
                    this.isdk = res.data.list[0].i_dkable;
                    this.i_issd=res.data.list[0].i_issd;
                    this.i_flag=res.data.list[0].i_flag;
                    this.f_sl = res.data.list[0].f_sl;
                    this.getkhlist();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    i_khtype:this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            yanzheng(){
                if(this.i_type==0){
                    this.$message.warning(this.$t('saleInvoicing_please_select_the_invoicing_type'));
                    return;
                }
                if(this.i_kpkhid==0){
                    this.$message.warning(this.$t('saleInvoicing_please_select_the_invoicing_party'));
                    return;
                }
                if(this.companyId==0){
                    this.$message.warning(this.$t('saleInvoicing_please_select_the_buyer'));
                    return;
                }
                this.beforehandle()
            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.i_origin_khtype = choo[0].i_origin_khtype;
                        this.vc_fymx = choo[0].vc_fymx;
                        //this.i_isagent=choo[0].i_isagent;
                        this.isdk=choo[0].i_dkable;
                        this.i_issd=choo[0].i_issd;
                        this.i_flag=choo[0].i_flag;
                        this.f_sl=choo[0].f_sl;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.getkhlist();
                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.i_origin_khtype=0;
                        this.vc_fymx = '';
                        //this.i_isagent=0;
                        this.isdk=0;
                        this.i_issd=0;
                        this.i_flag=0;
                        this.f_sl=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                    }
                }
                if(type=='state'){
                    this.isover=e;
                    let choo = this.stateData.filter(item=>{
                        return item.isover == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_isover=choo[0].vc_name;
                    }else{
                        this.vc_isover='';
                    }
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('saleInvoicing_please_select_the_invoice_type_first'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                            this.vc_khcreditcode=choo[0].vc_creditcode;
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }else{
                            this.vc_kpkhname='';
                            this.vc_khcreditcode='';
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }
                    }
                    /*if(this.i_kpkhid!=0&&this.companyId!=0&&this.isdk==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        this.beforehandle();
                    }*/
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                        this.vc_gscreditcode=choo[0].vc_creditcode;
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }else{
                        this.companyName='';
                        this.vc_gscreditcode='';
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }
                    /*if(this.i_kpkhid!=0&&this.companyId!=0&&this.isdk==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        this.beforehandle();
                    }*/
                }
                if(type=='xs'){
                    this.xsComId=e;
                    let choo = this.xsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.xsComname=choo[0].vc_name;
                        this.vc_khcreditcode=choo[0].vc_creditcode;
                    }else{
                        this.xsComname='';
                        this.vc_khcreditcode='';
                    }
                }
                if(type=='fplx'){
                    this.i_fptype=e;
                    let choo = this.fplxData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_fptype=choo[0].vc_name;
                    }else{
                        this.vc_fptype='';
                    }
                }
                if(type=='code'){
                    this.vc_fkey = e;
                    if(this.vc_fkey!=0){
                        this.beforedetail()
                    }
                }
                this.yanzheng()
            },
            clearsearch(type){
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.i_origin_khtype=0;
                    this.vc_fymx = '';
                    this.i_issd=0;
                    this.i_flag=0;
                    this.f_sl=0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    this.isover=null;
                    this.vc_isover='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.vc_khcreditcode='';
                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                    this.vc_gscreditcode='';
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                if(type=='xs'){
                    this.xsComId=0;
                    this.xsComname='';
                    this.vc_khcreditcode='';
                }
                if(type=='fplx'){
                    this.i_fptype=0;
                    this.vc_fptype='';

                }
                if(type=='code'){
                    this.vc_fkey = 0;
                }
                this.beforehandle();
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            // 验证发票池
            async syncState(row){
                let param = {
                    'i_gsid':this.companyId,
                    'invoiceCode':row.invoiceCode,
                    'invoiceNum':row.invoiceNum,
                    'electronicNumber':row.electronicNumber,
                };
                let res = await API.syncState(param);
                if (res.code == 1) {
                    if(this.i_fytype==1){
                        let list=this.deepClone(this.form.details)
                            list=this.groupAndSumByFsl(list)
                        //console.log('list',list)
                        delete this.form.details
                        this.form.details=list
                    }
                    let map={
                        name:this.fpData.name,
                        form:this.form,
                        i_isfrom:this.form.details.length==0?0:1,
                        //i_isfrom:1,
                    }
                    //console.log(map,'map')
                    //return
                    this.$emit('cancelDialog_fpcnew',map)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            groupAndSumByFsl(data){
                const resultMap = {};
                data.forEach(item => {
                    const key = item.f_sl;
                    if (!resultMap[key]) {
                        resultMap[key] = {
                            f_sl: key,
                            f_fppay_ws: 0,
                            f_fppay_zzs: 0,
                            vc_fppzname:item.vc_fppzname,
                            vc_fpbzstyle:null,
                            vc_fpunit:null,
                            f_fpnum:null,
                            f_fpprice:null,
                        };
                    }
                    resultMap[key].f_fppay_ws += Number(item.f_fppay_ws) || 0;
                    resultMap[key].f_fppay_zzs += Number(item.f_fppay_zzs) || 0;
                });
                return Object.values(resultMap);
            },
            //保存
            async saveForm(){
                this.$confirm(this.$t('saleInvoicing_confirm'), this.$t('saleInvoicing_hint'), {
                    confirmButtonText: this.$t('saleInvoicing_sure'),
                    cancelButtonText:this.$t('saleInvoicing_cancel'),
                    type: 'warning'
                }).then(() => {
                    //this.tableData.map(item=>item.json_invoice_data=JSON.stringify(item.json_invoice_data))
                    this.uploadAttachment()
                }).catch(() => {

                });

                /*if(this.vc_fkey){
                    if(this.form.vc_mainfile_newname==''){
                        this.$message.error('该发票没有附件不可选择！');
                        return;
                    }
                    this.syncState(this.form);

                } else{
                    this.$message.error('请选择要录入的发票编号！');
                    return;
                }*/
            },
            //
            async uploadAttachment(){
                let param = {
                    i_mid:this.mid,
                    ids:this.fpData.kpids,
                    invoiceEntities:this.tableData,
                    i_invoicetype:this.fpData.i_invoicetype,
                };
                let res = await API.uploadAttachment(param);
                if (res.code == 1) {
                    this.$emit('confirm',{
                        type:'save',
                    })
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('confirm',{
                    type:'back',
                })
            },
            clearFile(val,index){
                this.files.splice(index,1);
                this.vc_newname='';
                //this.files=[];
                //this.vc_newname='';
                this.vc_fpcode_upl='';
                this.vc_pz_upl='';
                this.f_pay_ws_upl='';
                this.f_pay_zzs_upl='';
                this.f_pay_upl='';
                this.vc_note_upl='';
                this.f_gs_upl='';
                //this.loading=true;
                //this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            async uploadFile2(e) {
                //this.loading_upl=true;
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                this.upfiles.push($files)
                let fileName = $files.name;
                let type = $files.type;
                //console.log(type,'type')
                //console.log($files,' $files')
                //console.log(upfiles,'upfiles')
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                //console.log(result,'result')
                if(($files && result==false) || ($files &&result==undefined)){
                    that.$message.error(this.$t('saleInvoicing_please_upload_a_file_with_the_correct_format'));
                    this.loading_upl=false;
                    return;
                };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "invoicepool",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "invoicepool",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadInvoice(param);
                    //let res = await API.upload(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        let file={
                            i_id:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname:res.data[0].filenewname,
                            vc_path:res.data[0].vc_path
                        }
                        /*this.formData.vc_files.otherfiles.push(file)*/
                        this.files.push(file);
                        this.vc_newname=res.data[0].vc_path;
                        //console.log(this.vc_newname,'this.vc_newname')
                        this.loading_upl=false;
                        this.$forceUpdate()
                        if(res.data[0].apicode==1){
                            let invoice = res.data[0].invoice;
                            let details = invoice.details;
                            this.details_upl = invoice.details;
                            let detailsL = invoice.details.length;
                            this.vc_fpcode_upl = invoice.vc_fpcode;
                            this.vc_pz_upl = detailsL==0?'':(detailsL==1?details[0].vc_fppzname:details[0].vc_fppzname+'等');
                            this.f_pay_ws_upl = invoice.f_pay_ws;
                            this.f_pay_zzs_upl = invoice.f_pay_zzs;
                            this.f_pay_upl = invoice.f_pay;
                            this.vc_note_upl = invoice.vc_note;
                            this.dt_fptime = invoice.dt_fptime;

                        }
                        /*let data = res.data[0];
                        var imgPath = {};
                        imgPath.i_fileid = data.i_id;
                        //imgPath.vc_name = data.filename;
                        imgPath.vc_path = file_root+data.vc_path;
                        //imgPath.base64 = data.base64String;
                        //imgPath.filePath = data.i_id;
                        //imgPath.fileSort = that.didNum;
                        //imgPath.fileType = 1;
                        //imgPath.filenewname = data.filenewname;
                        that.imgList.push(imgPath);
                        that.didNum++;
                        that.idNum = that.didNum;
                        that.imgLength = that.imgList.length - 1;
                        that.formData.imgList = that.imgList;
                        console.log(that.imgList,"that.imgList11111111111");*/

                    } else if (res.code == -2) {
                        this.loading_upl=false;
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.loading_upl=false;
                        this.$message.error(res.message);
                    }
                }
            },

            //获取orc
            async getOrc(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getOrc(param);
                if (res.code == 1) {
                    //console.log(res.data);
                    /*this.dt_fptime
                    this.vc_fpcode_upl
                    this.vc_pz_upl
                    this.f_pay_ws_upl
                    this.f_pay_zzs_upl
                    this.f_pay_upl
                    this.vc_note_upl*/
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

        }
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    .upload-demo {
       width: calc(100% - 80px) !important;
    }
    /deep/.el-input-number .el-input__inner{
        text-align: left;
    }
    .wid100{
        width: 100%;
    }
    .w66{
        width: 66%;
    }

    
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 180px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w25{
        width: 25%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex_e{
        display: flex;
        justify-content: flex-end;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .fl{
        float: left;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
    .img-box {
        margin: 0px;

        .uploadPhone {
            width: 70px;
            height: 80px;
            position: relative;
            width: 100%;
        }

        .uploadPhone img {
            width: 70px;
            height: 80px;
        }

        .upload-box {
            width: 30%;
            height: 30%;
        }

        .upload-input {
            position: absolute;
            opacity: 0;
            width: 70px;
            height: 80px;
        }
    }
</style>
